export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          {/* Brand */}
          <div className="flex items-center gap-3">
            <img
              src="https://public.readdy.ai/ai/img_res/39199950-a34f-4b9b-8bf8-8b3e8ec1743f.png"
              alt="ALFA DOO Logo"
              className="h-9 w-auto object-contain"
            />
            <div>
              <p className="font-bold text-lg tracking-wide">ALFA DOO</p>
              <p className="text-slate-400 text-xs">iOS App Development Experts</p>
            </div>
          </div>

          {/* Nav links */}
          <nav className="flex flex-wrap gap-6">
            {['Home', 'Products', 'Features', 'About', 'Contact'].map((item) => (
              <a
                key={item}
                href={`#${item.toLowerCase()}`}
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.getElementById(item.toLowerCase());
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="text-slate-400 hover:text-white text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                {item}
              </a>
            ))}
          </nav>
        </div>

        <div className="border-t border-slate-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-xs">
            &copy; {new Date().getFullYear()} ALFA DOO. All rights reserved.
          </p>
          <p className="text-slate-600 text-xs">
            Kragujevac, Serbia &mdash; info@alfadoo.net
          </p>
        </div>
      </div>
    </footer>
  );
}
